import React, { useEffect, useState } from 'react';
import { cart } from '../Reducers/Cart.reducer';
import { useDispatch } from 'react-redux';
import { translate } from '../Services/translation';
import MiniCartProduct from './MiniCart.Product';
import SideMenu from './SideMenu';
import MiniCartErrorMessage from './MiniCart.ErrorMessage';
import { show } from '../Actions/LightboxImages.action';
import { shouldShowErrorMessage } from '../Actions/Cart.action';
import { dataLayerGtmViewCart } from '../Services/Gtm.service';
import CartDiscount from './CartDiscount';

const MiniCart = (props) => {
  const {
    orderRows,
    discountRows,
    grandTotal,
    isShippingSet,
    deliveryCost,
    discount,
    shippingInfoText,
    quantity,
    checkoutUrl,
    visible,
    shouldClose,
    showMiniCart,
    onClosed,
    updateRow,
    paymentLogos,
    addedTooManyProducts,
    orderTotal,
    includeVat,
    miniCartTotal,
    gtmGrandTotal,
  } = props;
  const dispatch = useDispatch();
  const header = (
    <>
      <span className="text-medium color-grey-900 bold">
        {translate('minicart.title')}&nbsp;
      </span>
      <span className="[ cart-container__quantity-text ] [ text-medium color-grey-500 ]">
        ({quantity})
      </span>
    </>
  );
  const footer = (
    <div className="cart-container__footer">
      <div className="cart-container__footer-price-row cart-container__footer-price-row--total">
        <div>
          {includeVat
            ? translate('minicart.total-inc-vat')
            : translate('minicart.total-exc-vat')}
        </div>
        <div>{miniCartTotal}</div>
      </div>
      {quantity != 0 && (
        <a
          href={checkoutUrl}
          className="btn btn--large btn--secondary btn--form"
        >
          {translate('minicart.checkout')}
        </a>
      )}
      <div className="cart-container__footer--extra-info">
        <div className="cart-container__footer--extra-info--logos">
          {paymentLogos?.length > 0 &&
            paymentLogos.map((logo, index) => (
              <img alt="" key={logo + index} src={logo} />
            ))}
        </div>
      </div>
    </div>
  );

  const onClickShowMiniCart = () => {
    showMiniCart();

    try {
      let gtmOrderRows = [];

      orderRows.map(row => {
        const gtmOrderRowIndex = gtmOrderRows.findIndex(e => e.articleNumber === row.articleNumber);

        if (gtmOrderRowIndex === -1) {
          row.gtmEcommerceItem.quantity = row.quantity;
          row.gtmEcommerceItem.index = gtmOrderRows.length;
          gtmOrderRows.push(row);
        } else {
          gtmOrderRows[gtmOrderRowIndex].gtmEcommerceItem.quantity += row.quantity;
        }
      });

      if (gtmOrderRows.length > 0) {
        dataLayerGtmViewCart({
          currency: gtmOrderRows[0].gtmEcommerceItem.currency,
          gtmGrandTotal: gtmGrandTotal,
          orderRows: gtmOrderRows
        });
      }
    } catch (err) { }
  };

  return (
    <div className="cart cart--mini">
      <button
        className="[ cart__button header__menu-icon ] [ flex-container align-middle ]"
        onClick={() => onClickShowMiniCart()}
      >
        {quantity > 0 && (
          <span className="cart__quantity bg-white">{quantity}</span>
        )}
        <i className="ph-shopping-cart ph-xl color-grey-900"></i>
        <span className="text-small text-medium-from-medium lh-2 color-grey-900">
          {translate('minicart.checkout')}
        </span>
      </button>
      <SideMenu
        id="MiniCart"
        header={header}
        footer={footer}
        open={visible}
        onClosed={onClosed}
        className="cart-container"
      >
        <>
          <div className="cart-container__items">
            {orderRows.length > 0 ? (
              <>
                {orderRows.map((row) => (
                  <MiniCartProduct
                    key={row.rowSystemId}
                    product={row}
                    onQuantityChange={(quantity) =>
                      updateRow(row.articleNumber, quantity, row.rowSystemId)
                    }
                    deleteRow={() =>
                      updateRow(row.articleNumber, 0, row.rowSystemId)
                    }
                  />
                ))}

                {discountRows.map((row) => (
                  <div className="cart-container__item-wrapper">
                    <CartDiscount discountRow={row} />
                  </div>
                ))}
              </>

            ) : (
              <div className="cart-container__item">
                {translate('minicart.empty')}
              </div>
            )}
          </div>
        </>
      </SideMenu>
    </div>
  );
};

export default MiniCart;
